<label class="switch-container" for="switch-{{ id }}">
  <div class="off-label">
    <ng-content select="[offLabel]"></ng-content>
  </div>
  <app-switch [smallish]="true">
    <input
      type="checkbox"
      id="switch-{{ id }}"
      [(ngModel)]="value"
      (ngModelChange)="switch(value)"
      [disabled]="disabled"
    />
    <label for="switch-{{ id }}"></label>
  </app-switch>
  <div class="on-label">
    <ng-content select="[onLabel]"></ng-content>
  </div>
</label>
